module.exports = __webpack_public_path__ + "img/郁金香-1.b94d7f96.jpg";